import type { CSSProperties, ReactNode } from 'react'
import { DATE, LINE_GAP, MONO, PAD_X, PAD_Y, PILL_VARS, SANS, TITLE, type PillKind, type PlacedPill } from '@/lib/readiness/annotationLayout'

// Annotation pills (Iteration 4 §4.2): the SVG pill drawn inside the chart and
// the same pill in HTML for the Technology detail timeline bar. Layout lives in
// engine/annotationLayout.

export function SvgPill({ p }: { p: PlacedPill }) {
  const c = PILL_VARS[p.kind]
  return (
    <g data-testid={p.testId} data-pill={p.kind}>
      <rect x={p.x} y={p.y} width={p.w} height={p.h} rx={7} fill={c.bg} stroke={c.fg} strokeOpacity={0.5} strokeWidth={1} />
      <text x={p.x + PAD_X} y={p.y + PAD_Y + TITLE - 2} fontSize={TITLE} fontWeight={700} fill={c.fg} style={{ fontFamily: SANS }}>{p.title}</text>
      {p.date && <text x={p.x + PAD_X} y={p.y + PAD_Y + TITLE + LINE_GAP + DATE - 1.5} fontSize={DATE} fill={c.fg} style={{ fontFamily: MONO }}>{p.date}</text>}
      {p.full && <title>{p.full}</title>}
    </g>
  )
}

// The same pill in HTML (Technology detail timeline bar).
export function HtmlPill({ kind, title, date, style, testId, children }: { kind: PillKind; title: string; date?: ReactNode; style?: CSSProperties; testId?: string; children?: ReactNode }) {
  const c = PILL_VARS[kind]
  return (
    <span className="rd-pill" style={{ background: c.bg, color: c.fg, borderColor: `color-mix(in srgb, ${c.fg} 50%, transparent)`, ...style }} data-testid={testId}>
      <span className="rd-pill-title">{title}</span>
      {date && <span className="rd-pill-date">{date}</span>}
      {children}
    </span>
  )
}
